import { ChevronLeft, ChevronRight } from '@/components/ui/icons';
import { cn } from '@/lib/utils';

interface NavButtonsProps {
  canBack: boolean;
  canForward: boolean;
  onBack: () => void;
  onForward: () => void;
}

// 25% smaller than the original h-6/w-6 (24px → 18px) with a matching 12px icon.
const baseClass =
  'flex h-[18px] w-[18px] items-center justify-center rounded border border-[#737373] text-telekinesis-text-secondary transition-colors';
const enabledClass =
  'hover:border-[#107d40] hover:bg-[#0f3d24] hover:text-[#107d40]';
const disabledClass = 'cursor-default opacity-40';

/**
 * Browser-style Back / Forward buttons for the feature toolbar. Rendered in the
 * top-left, directly above the domain dropdown. Each greys out (disabled) when
 * there is nowhere left to go in that direction — Back at the start of history,
 * Forward at the end.
 */
export function NavButtons({
  canBack,
  canForward,
  onBack,
  onForward,
}: NavButtonsProps) {
  return (
    <div className="flex items-center gap-1">
      <button
        type="button"
        onClick={onBack}
        disabled={!canBack}
        aria-label="Back"
        className={cn(baseClass, canBack ? enabledClass : disabledClass)}
      >
        <ChevronLeft className="h-3 w-3" />
      </button>
      <button
        type="button"
        onClick={onForward}
        disabled={!canForward}
        aria-label="Forward"
        className={cn(baseClass, canForward ? enabledClass : disabledClass)}
      >
        <ChevronRight className="h-3 w-3" />
      </button>
    </div>
  );
}
